import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const Search: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  fillOpacity,
}) => (
  <SvgWrapper viewBox={viewBox} size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.92657 2.00034c1.05053-.00965 2.09263.18772 3.06693.58083.9742.39312 1.8615.97427 2.6112 1.71029.7496.73602 1.347 1.61249 1.7579 2.57936.8299 1.95269.8502 4.15508.0562 6.12268-.3108.7703-.7364 1.4799-1.2565 2.1081l5.618 5.6181c.2929.2929.2929.7677 0 1.0606-.2929.2929-.7677.2929-1.0606 0l-5.6181-5.618c-.5907.4891-1.2538.8949-1.9724 1.2003-1.9527.8299-4.1551.8501-6.1227.0562-1.96759-.7939-3.53921-2.3369-4.36912-4.2896-.41093-.9669-.6274-2.0052-.63704-3.0558-.00965-1.0505.18772-2.09264.58083-3.0669.39312-.97425.97427-1.86154 1.71029-2.61119.73602-.74966 1.61249-1.347 2.57936-1.75793.96687-.41093 2.00522-.6274 3.05575-.63704ZM12.4322 3.9722c-.7916-.3194-1.6383-.47976-2.49186-.47193-.85356.00784-1.69721.18372-2.4828.5176-.78558.33388-1.49771.81922-2.09573 1.42832-.59801.60909-1.0702 1.33001-1.38961 2.12159-.3194.79159-.47976 1.63833-.47193 2.49192.00784.8535.18372 1.6972.5176 2.4828.6743 1.5865 1.95124 2.8402 3.54991 3.4853 1.59868.6451 3.38812.6286 4.97472-.0457 1.5865-.6743 2.8402-1.9512 3.4853-3.5499.6451-1.5987.6286-3.3881-.0457-4.97466-.3338-.78558-.8192-1.49771-1.4283-2.09573-.6091-.59801-1.33-1.0702-2.1216-1.38961Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  </SvgWrapper>
)

export default Search
